<template>
    <div class="class-and-stu">
        <div>
            <Title :title="'路径管理'"></Title>
            <div class="manage-area-main" style="margin-top: 20px">
                <div>
                    <Button type="primary" @click="createPathBtn">添加路径</Button>
                </div>
                <div style="padding: 20px;background: #ffffff">
                    <Table :columns="columns" :data="path_list.body"></Table>
                    <div  class="page-box" v-if="path_list.page">
                        <Page show-sizer
                              show-total
                              :page-size="path_list.page.page_size"
                              :current="path_list.page.current"
                              :total="path_list.page.count"
                              @on-change="currentPage"
                              @on-page-size-change="pageSizeChange"
                        />
                    </div>
                </div>
            </div>
        </div>
        <Modal
        v-model="allotModel"
        title="分配学院"
        width="450"
        @on-ok="allotOk"
        >
            <p>
                <span style="margin-right: 20px">学院名称</span>
                <Select v-model="allocationArr" multiple style="width:260px">
                    <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                </Select>
            </p>

        </Modal>
    </div>
</template>

<script>
    import Title from '../../../ability/components/title'
    import {mapActions, mapState} from 'vuex'
    import moment from "moment";
    export default {
        name: "pathList",
        components: {
            Title,
        },
        data() {
            return {
                page_num:1,
                page_size:20,
                allocationArr:[],
                allotModel:false,
                columns: [
                    {
                        type: 'index',
                        title: '序号',
                        width:70,
                    },
                    {
                        title:'路径名称',
                        key:'name'
                    },
                    {
                        title:'创建时间',
                        key:'ctime',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss ')),
                            ]);
                        }
                    },
                    {
                        title:'状态',
                        key:'status',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, params.row.is_release == 1 ?'未发布':'已发布'),
                            ]);
                        }
                    },
                    {
                        title:'类型',
                        key:'path_nature_name',
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.allotCollege(params.row)
                                        }
                                    }
                                }, '分配学院'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.viewDetails(params.row)
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editPath(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.path_nature !== 1 ?'none':'inline-block'
                                    },
                                    on: {
                                        click: () => {
                                            this.delCurPath(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        },
        computed: {
            ...mapState({
                path_list: state => state.path.path_list,
                colleges_info:state => state.colleges.colleges_info
            }),
        },
        methods: {
            ...mapActions({
                getPathList: 'path/getPathList',
                getColleges:'colleges/getColleges',
                delPath:'path/delPath',
                pathAllot:'path/pathAllot'
            }),
            createPathBtn(){
                this.$router.push({
                    name: 'create-path',
                })
            },
            viewDetails(row){
                this.$router.push({
                    name: 'pathDetails',
                    params: {path_id: row.id,page:'details'},
                })
            },
            editPath(row){
                this.$router.push({
                    name: 'pathEdit',
                    params: {path_id: row.id},
                })
            },
            //分配学院
            allotCollege(row){
                this.allotModel=true
                this.path_id = row.id
                if(row.college_list.length>0){
                    this.allocationArr = row.college_list
                }else{
                    this.allocationArr = []
                }
                this.getColleges()
            },
            allotOk() {
                let _this = this
                this.pathAllot({
                    path_id: _this.path_id,
                    data: {
                        college_ids: _this.allocationArr
                    },
                    callback: res => {
                        _this.$Message.success(res)
                        this.initpath()
                    },error:msg =>{
                        _this.$Message.error(msg)
                    }
                })
            },
            currentPage(num){
                this.page_num = num
                this.initpath()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initpath()
            },
            delCurPath(row){
                let _this = this
                this.$Modal.confirm({
                    title: '删除路径',
                    content: `确认要删除<b style="color: #2b85e4">${row.name}</b>吗！`,
                    cancelText: '取消',
                    onOk:function(){
                        _this.delPath({
                            path_id:row.id,
                            callback:res =>{
                                _this.$Message.success(res)
                                _this.initpath()
                            },
                            error:msg =>{
                                _this.$Message.error(msg)
                            }
                        })
                    }
                });
            },
            cancel(){

            },
            initpath(){
                let _this = this
                this.getPathList({
                    sort:'-name|ctime',
                    page_num:_this.page_num,
                    page_size:_this.page_size
                })
            }

        },
        mounted () {
            this.initpath()
        },
    }
</script>
<style scoped lang="less">
    @import "../../style/index";
    .add-class-form{

    }
</style>
